$(document).ready(function() {
$('#menu-selection').on('change', function() {
	//var menuHeaderHeight = $('.concession-menu-header')[0].clientHeight;
	//var negativeMenuHeaderHeight = menuHeaderHeight * -1;
	//window.location(this.value);
	//window.scrollBy(0,negativeMenuHeaderHeight);
	console.log(this.value);
	scrollToMenu(this.value);
});

$('.concession-link-url').on("click", function(event) {
	event.preventDefault();
	console.log($(this).attr("value"));
	scrollToMenu($(this).attr("value"));
});

function scrollToMenu(node) {
	var menuHeader = $('.concession-menu-header')[0];
	var menuHeaderHeight = (menuHeader ? menuHeader.clientHeight : 0) + 75;
	var negativeMenuHeaderHeight = menuHeaderHeight * -1;
	window.location = node;
window.scrollBy({
  top: negativeMenuHeaderHeight,
  behavior: 'smooth',
});
}
});